import React from "react";
import Navbar from "../Navbar/Navbar";
import MobileNavbar from "../MobileNavbar/MobileNavbar";
import Footer from "../Footer/Footer";
import SeoHead from "../SeoHead";
import { BreadcrumbJsonLd, WebPageJsonLd } from "../JsonLd";
import { SITE_URL, absoluteUrl } from "../../config/seo";

/**
 * SiteChrome — shared layout for marketing pages.
 * Emits title, description, canonical, Open Graph, WebPage schema,
 * and a Home breadcrumb for every indexed page with a canonical URL.
 *
 * Props:
 *   title, description, canonical, ogImage, keywords, ogType
 *   crumb       string  Short breadcrumb label (defaults to the title before "|")
 *   crumbs      array   Override breadcrumb items [{ name, url }]
 *   noIndex     bool
 *   hideFooter  bool
 *   topOffset   bool    Pads content below the fixed navbar (default true)
 */
const SiteChrome = function (props) {
  var topOffset = props.topOffset !== false;
  var canonical = props.canonical ? absoluteUrl(props.canonical) : "";
  var crumbName = props.crumb
    || (props.title ? String(props.title).split("|")[0].trim() : "");
  var isHome = canonical === SITE_URL || canonical === SITE_URL + "/";
  var crumbs = props.crumbs;
  if (!crumbs && canonical && !props.noIndex && !isHome && crumbName) {
    crumbs = [
      { name: "Home", url: SITE_URL + "/" },
      { name: crumbName, url: canonical }
    ];
  }

  return (
    <div className="pa-shell">
      <SeoHead
        title={props.title}
        description={props.description}
        canonical={canonical || undefined}
        ogImage={props.ogImage}
        keywords={props.keywords}
        noIndex={props.noIndex}
        ogType={props.ogType}
      />
      {canonical && !props.noIndex ? (
        <WebPageJsonLd title={props.title} description={props.description} url={canonical} />
      ) : null}
      {crumbs && crumbs.length ? <BreadcrumbJsonLd items={crumbs} /> : null}
      <Navbar />
      <MobileNavbar />
      <main className={"pa-shell__main" + (topOffset ? " pa-shell__main--offset" : "")}>
        {props.children}
      </main>
      {props.hideFooter ? null : <Footer />}
    </div>
  );
};

export default SiteChrome;
